module.exports = __webpack_public_path__ + "img/icon4.b1ad321a.jpg";